import styled from 'styled-components';
import { GetColor, Label } from 'venn-ui-kit';

export const StyledSymbol = styled.span`
  border-radius: 2px;
  font-size: 11px;
  text-align: center;
  font-weight: bold;
  margin-top: -1px;
  color: ${GetColor.White};
  display: inline;
  background: ${GetColor.DarkGrey};
  padding: 1px 5px;
  margin-right: 6px;
`;

export const StyledLabel = styled(Label)`
  line-height: 16px;
`;
